import { createBrowserHistory } from 'history'

export const history = createBrowserHistory({basename:'/vaccine_reservation'})